module.exports = __webpack_public_path__ + "static/img/hover_btn_gzh.7ffe950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hover_btn_gzh.png
// module id = dcur
// module chunks = 1